import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import GlobalStyle from './styles/global';
import AppProvider from './hooks/index';
import Routes from './routes';
import Maintenance from './pages/Maintenance';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';

// Set to true to show the maintenance page for all visitors. Set back to false when maintenance is complete.
const MAINTENANCE_MODE = false;

function App() {
    if (MAINTENANCE_MODE) {
        return (
            <BrowserRouter>
                <RouterRoutes>
                    <Route path="*" element={<Maintenance />} />
                </RouterRoutes>
                <GlobalStyle />
            </BrowserRouter>
        );
    }

    return (
        <BrowserRouter>
            <AppProvider>
                <Routes />
            </AppProvider>
            <GlobalStyle />
        </BrowserRouter>
    );
}

export default App;
